import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "pending-requests" }
const _hoisted_2 = { class: "heading" }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 0,
  class: "scroll-y"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "req-val start-date" }
const _hoisted_7 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("aside", _hoisted_1, [
    _createElementVNode("h3", _hoisted_2, [
      _cache[3] || (_cache[3] = _createTextVNode("Pending Requests")),
      _createElementVNode("img", {
        src: $setup.UndoIcon,
        class: _normalizeClass({loading: $setup.requestStore.loading}),
        onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.requestStore.reloadRequests()))
      }, null, 10, _hoisted_3)
    ]),
    ($setup.signedRequests.length > 0)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.signedRequests, (request) => {
            return (_openBlock(), _createElementBlock("li", {
              key: `req-${request.dogId}`
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["pending-request", {active: $setup.selectedRequest === request.$id}]),
                onClick: ($event: any) => ($setup.selectedRequest = request.$id)
              }, [
                _createElementVNode("div", {
                  class: "req-val event-type",
                  style: _normalizeStyle(`background-color: ${$setup.getEventColor(request)}`)
                }, _toDisplayString($setup.Events.EventTypeMap[request.eventType]) + _toDisplayString('trainingType' in request ? `: ${request.trainingType}` : null), 5),
                _createElementVNode("div", {
                  class: "req-val dog-size",
                  style: _normalizeStyle(`background-color: ${$setup.getSizeColor($setup.dogStore.dogs[request.dogId])}`)
                }, _toDisplayString($setup.dogStore.dogs[request.dogId]?.size || "Unknown"), 5),
                _createElementVNode("div", _hoisted_6, _toDisplayString(new Date(request.startTime).toLocaleDateString()), 1)
              ], 10, _hoisted_5)
            ]))
          }), 128)),
          ($setup.selectedRequest)
            ? (_openBlock(), _createBlock($setup["UpdateRequest"], {
                key: 0,
                class: "request-modal",
                id: $setup.selectedRequest,
                onClose: _cache[1] || (_cache[1] = ($event: any) => ($setup.selectedRequest = null)),
                onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
              }, null, 8, ["id"]))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _cache[4] || (_cache[4] = _createElementVNode("p", null, "All caught up", -1)),
          ($setup.requestStore.pendingRequests.length - $setup.signedRequests.length > 0)
            ? (_openBlock(), _createElementBlock("p", _hoisted_7, " There " + _toDisplayString($setup.requestStore.pendingRequests.length - $setup.signedRequests.length > 1 ? 'are' : 'is') + " " + _toDisplayString($setup.requestStore.pendingRequests.length - $setup.signedRequests.length) + " unsigned " + _toDisplayString($setup.requestStore.pendingRequests.length - $setup.signedRequests.length > 1 ? 'requests' : 'request'), 1))
            : _createCommentVNode("", true)
        ], 64))
  ]))
}